import { decode } from '@/utils/base64';
import Cookies from 'js-cookie'

export enum TokenType {
    "Bearer",
    "None"
}

export interface Token {
    value: string;
    type: TokenType;
    expiresIn?: string;
    refresh?: string;
    [key: string]: any;
}


export function parse (tokenValue: string) {
    const webToken: Token = { value: tokenValue, type: TokenType.Bearer};
    return webToken;
}



const TOKEN_COOKIE_KEY = 'yc_erp_token'

export function get(): string {
    return Cookies.get(TOKEN_COOKIE_KEY)
}

export function setToken(value: string): void {
    return Cookies.set(TOKEN_COOKIE_KEY, value)
}

export function clear(): void {
    return Cookies.remove(TOKEN_COOKIE_KEY)
}


export function getSessionID(): string {
    return Cookies.get('session_id');
}

const COOKIE_USER_ID = '_userId'
export function getUserId(): string {
    return Cookies.get(COOKIE_USER_ID)
}
export function setUserId(value: string): void {
    return Cookies.set(COOKIE_USER_ID, value)
}
export function removeUserId(): void {
    return Cookies.remove(COOKIE_USER_ID)
}
